import React from "react";
import { Link } from "react-router-dom";
import PageLayout from "../layouts/MainLayout";
import { Container, Row, Col } from "react-grid-system";
import Alert from "../components/Alert/Alert";
import BuilderSearchForm from "../components/SearchForms/BuilderSearchForm";
import EnrolmentSearchForm from "../components/SearchForms/EnrolmentSearchForm";
import { FiExternalLink } from "react-icons/fi";

const profileLink = () => {
  return "/profile/";
};

const SearchPage = () => {
  return (
    <PageLayout
      home={true}
      pageHeader={
        <>
          <span className="bold">Ontario</span> Builder Directory
        </>
      }
    >
      <p>
        In Ontario, all new home builders and sellers must be licensed by the{" "}
        <a href="http://www.hcraontario.ca">
          {" "}
          Home Construction Regulatory Authority (HCRA)
        </a>
        .
      </p>
      <p>
        Hosted by the HCRA, the Ontario Builder Directory provides key
        information such as a builder’s licensing status, years of activity,
        number of homes built, and any regulatory actions taken by the HCRA,
        including conduct concerns, charges, and convictions against the
        builder.
      </p>
      <p>
        If a builder is not listed in the Builder Directory, it is likely
        they’re not operating legally.{" "}
        <b>If a builder is not licensed, do not buy from them!</b> Please
        contact the HCRA for more information if you are unsure.
      </p>
      <p>
        Start your search by entering the builder’s name. You can also refine
        your results using filters like insolvency status or the name of a
        company director or officer. Those interested in buying a resale of a
        home built within the last seven years can also search the Builder
        Directory to confirm the home’s warranty coverage.
      </p>

      <Container>
        <Row align="stretch">
          <Col md={12} lg={4} style={{ marginBottom: `2rem` }}>
            <h2>Search for a Builder</h2>
            <BuilderSearchForm />
          </Col>

          <Col md={12} lg={4}>
            <h2>Confirm Your Home's Warranty</h2>
            <EnrolmentSearchForm />
            <span className="footnote">
              *All warranty information is updated with Tarion data that is
              shared with the HCRA for posting to a builder’s profile.
            </span>
          </Col>

          <Col md={12} lg={4}>
            <h2>
              Search for regulatory
              <br />
              activities & enforcement
            </h2>
            <p>
              <Link
                className="title"
                key="ccoac"
                to="/charges-and-convictions/"
              >
                <FiExternalLink
                  style={{
                    verticalAlign: "center",
                    marginRight: ".5rem",
                    fontSize: `1.5rem`,
                  }}
                />
                Court Charges and/or Convictions
              </Link>
            </p>
            <p>
              <Link className="title" key="roaoa" to="/notices-and-orders/">
                <FiExternalLink
                  style={{
                    verticalAlign: "center",
                    marginRight: ".5rem",
                    fontSize: `1.5rem`,
                  }}
                />
                Registrar's Orders and Other Actions
              </Link>
            </p>
            <p>
              <Link className="title" key="ccoac" to="/disclipline-appeals/">
                <FiExternalLink
                  style={{
                    verticalAlign: "center",
                    marginRight: ".5rem",
                    fontSize: `1.5rem`,
                  }}
                />
                Discipline & Appeals Committees Proceedings and Orders
              </Link>
            </p>
          </Col>
        </Row>
      </Container>
    </PageLayout>
  );
};

export default SearchPage;
